import { baseURL, HttpMethods, makeRequest } from '@/libs/http.config';

export const getAllCustomFields = async () => {
  return await makeRequest({
    url: `${baseURL}custom-fields`,
    method: HttpMethods.GET,
  });
};

export const updateCustomFieldForEntity = async (fieldId: string, data: any) => {
  return await makeRequest({
    url: `${baseURL}custom-fields/${fieldId}/data`,
    method: HttpMethods.POST,
    data,
  });
};

export const deleteCustomFieldForEntity = async (fieldId: string, data: any) => {
  return await makeRequest({
    url: `${baseURL}custom-fields/${fieldId}/data`,
    method: HttpMethods.DELETE,
    data,
  });
};
